import React, { useEffect, useState } from "react";
import { PageHeader } from "../../Components";
import { getCMS } from "../../Services/Api/Api";
import "./TermsConditions.css";
import { scrollTop } from "../../Services/Utils/Utils";

const TermsCondtions = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    scrollTop();
    getData();
  }, []);

  const getData = async () => {
    const result = await getCMS("terms-n-condition");
    const { data, status, error } = result;
    if (status === 200) {
      setData(data?.cms);
    } else {
      console.log(error);
    }
  };

  return (
    <div>
      <PageHeader pageTitle="Terms & Conditions" />
      <div className="terms-condition">
        <div className="container">
          {data
            ?.filter((item) => item.active)
            .map((item, index) => (
              <div key={index}>
                <h3 className="heading"> {item?.title} </h3>
                <div className="border"></div>
                <div className="desc">{item?.description}</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TermsCondtions;